import { __awaiter, __generator } from "tslib";
import React from 'react';
import { Box, Text, TextButton } from "wix-style-react";
import { ThumbsUp } from "wix-ui-icons-common";
import { deleteLikeToReview, getReview, postLikeToReview } from "../../../../../api/api";
import { composer } from "../../../../../component-decorators/composer";
import { biLogger } from "../../../../../bi";
import { useConfigContext } from "../../../../../config-context";
export var HelpfulReview = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, appId = _a.appId, review = _a.review;
    // tslint:disable-next-line:react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(0), showTextHelpfulReview = _b[0], updateShowTextHelpfulReview = _b[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _c = React.useState(review), reviewInfo = _c[0], updateReviewInfo = _c[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _d = React.useState({ text: "solution.page.afterLikeOnReview",
        secondary: false, skinColor: "success" }), textUnderButton = _d[0], updateTextUnderButton = _d[1];
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () { setTimeout(function () { return updateShowTextHelpfulReview(0); }, 5000); }, [showTextHelpfulReview]);
    // tslint:disable-next-line:no-shadowed-variable
    var clickLikeReview = function (appId, reviewId, etag, userOpinion) { return __awaiter(void 0, void 0, void 0, function () {
        var sendBi, _a, _b, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    sendBi = function (value) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, biLogger.appMarketLikeUnlikeAppReview({
                                        helpful_click: value,
                                        appId: appId
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!(userOpinion === null || userOpinion === void 0 ? void 0 : userOpinion.like)) return [3 /*break*/, 4];
                    return [4 /*yield*/, deleteLikeToReview(appId, reviewId, etag, userOpinion.id)];
                case 1:
                    _c.sent();
                    _a = updateReviewInfo;
                    return [4 /*yield*/, getReview(appId, reviewId, etag)];
                case 2:
                    _a.apply(void 0, [_c.sent()]);
                    return [4 /*yield*/, sendBi("unlike")];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 4:
                    _c.trys.push([4, 8, , 9]);
                    return [4 /*yield*/, postLikeToReview(appId, reviewId, etag)];
                case 5:
                    _c.sent();
                    _b = updateReviewInfo;
                    return [4 /*yield*/, getReview(appId, reviewId, etag)];
                case 6:
                    _b.apply(void 0, [_c.sent()]);
                    updateShowTextHelpfulReview(1);
                    return [4 /*yield*/, sendBi("like")];
                case 7:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _c.sent();
                    if (error_1.response.status === 401) {
                        updateTextUnderButton({ text: "solution.page.tryingLikeNotLoggedIn",
                            secondary: true, skinColor: "standard" });
                        updateShowTextHelpfulReview(1);
                    }
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return !isMobile ? (React.createElement(Box, { align: "right", marginBottom: "35px", direction: "vertical" },
        React.createElement(Box, null,
            React.createElement(TextButton, { weight: "thin", prefixIcon: React.createElement(ThumbsUp, null), dataHook: "helpful-button", style: { marginRight: "6px" }, as: "button", onClick: function () { return clickLikeReview(appId, reviewInfo.id, reviewInfo.etag, reviewInfo.userOpinion); } }, t('solution.page.helpfulReviews')),
            React.createElement(Text, { skin: "standard", secondary: true, weight: "thin", style: { marginBottom: "6px" }, dataHook: "total-likes" }, "(" + reviewInfo.totalLikes + ")")),
        React.createElement(Box, { opacity: showTextHelpfulReview, transitionDuration: "0.35s", transitionProperty: "opacity", transitionTimingFunction: "ease" },
            React.createElement(Text, { secondary: textUnderButton.secondary, skin: textUnderButton.skinColor, weight: "thin", size: "tiny", dataHook: "helpful-subtitle" }, t(textUnderButton.text))))) : null;
});
//# sourceMappingURL=helpful-review.js.map